// extracted by mini-css-extract-plugin
export default {"wrapper":"MinerDataCopy_wrapper__B3AK6","data_copy":"MinerDataCopy_data_copy__V+VVb","btn":"MinerDataCopy_btn__5rDPT"};